import { render, staticRenderFns } from "./ShowNumber.vue?vue&type=template&id=a36db196&scoped=true&"
import script from "./ShowNumber.vue?vue&type=script&lang=js&"
export * from "./ShowNumber.vue?vue&type=script&lang=js&"
import style0 from "./ShowNumber.vue?vue&type=style&index=0&id=a36db196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36db196",
  null
  
)

export default component.exports